module.exports = __webpack_public_path__ + "static/media/fail.7bd85396.png";